import styled, { css } from 'styled-components';
import { FontSize, inputStyle, spacing } from 'commons';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 5px;
  font-size: ${FontSize.font12};

  input {
    display: flex;
    font-size: ${FontSize.font12};
    font-weight: ${inputStyle.fontWeight};
    outline: none;
    width: inherit;
    height: inherit;
    background-color: transparent;

    &::placeholder {
      opacity: ${inputStyle.placeholderOpacity};
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      box-shadow: inset 0 0 0 500px white;
    }
  }

  input[type='date'] {
    display: flex;

    &::-webkit-calendar-picker-indicator {
      margin: 0;
      cursor: pointer;
    }
  }

  @media only screen and (max-width: 480px) {
    input {
      padding: 8px 0;
    }
  }
`;

export const Label = styled.label`
  display: block;
  font-weight: 700;
`;

const InputWrapper_success = css`
  border-color: ${({ theme }) => theme.success_300};
  color: ${({ theme }) => theme.success_300};
`;

const InputWrapper_error = css`
  border-color: ${({ theme }) => theme.danger_500};
  color: ${({ theme }) => theme.danger_500};
`;

const variants = {
  default: '',
  success: InputWrapper_success,
  error: InputWrapper_error,
};

export const InputWrapper = styled.div<{
  $variant: 'default' | 'success' | 'error';
  $readOnly: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  border-radius: ${spacing.input.borderRadius};
  height: ${spacing.input.height};
  background-color: ${({ theme }) => theme.neutral_100};
  border: 1px solid ${({ theme }) => theme.neutral_500};
  color: ${({ theme }) => theme.neutral_900};
  padding: 0 16px;

  ${({ $variant }) => variants[$variant]}
  ${({ $readOnly }) =>
    $readOnly &&
    css`
      border: 1px solid ${({ theme }) => theme.neutral_300};
      background-color: ${({ theme }) => theme.neutral_200};
      input {
        color: ${({ theme }) => theme.neutral_500};
      }
    `}
`;

export const MessageWrapper = styled.div`
  display: flex;
`;

export const Error = styled.label`
  padding-left: 5px;
  font-weight: bold;
  white-space: nowrap;
  color: ${({ theme }) => theme.danger_500};

  :empty {
    display: none;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 5px;
`;
